<template>
  <div class="card">
    <div class="card-header">
      <span class="card-header-title"
        >2FA
        <span class="margin-left-1  tags has-addons has-text-weight-normal	">
          <span class="tag">Expires</span>
          <span class="tag is-primary">{{ timeLeft }}</span>
        </span>
      </span>
    </div>

    <div class="card-content">
      <form @submit.stop.prevent="send()">
        <p>
          An e-mail with a code has been sent to your inbox. It can take a while
          for the e-mail to arrive.
        </p>

        <CheckboxText
          v-if="data.twoFactorWhen !== 'always'"
          :checked="trustBrowser"
          @click="trustBrowser = !trustBrowser"
          >Remember this browser</CheckboxText
        >

        <BForm
          class="margin-top-10"
          :elements="form"
          mode="lazy"
          @valid="form.valid = $event"
          @submit="send()"
        ></BForm>

        <section class="footer-container">
          <button
            :class="{ 'is-loading': isLoading }"
            :disabled="isLoading || !form.valid"
            class="button is-primary"
            type="submit"
          >
            Send
          </button>
        </section>
      </form>

      <section class="buttons-section">
        <button
          type="button"
          class="simple-button is-fullwidth"
          @click.stop.prevent="$emit('action', 'signin')"
        >
          Go to sign in
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import { setAuth, reroute } from "@/utils/auth";
import { loadSettings } from "@/utils/app";

export default {
  components: {
    BForm: () => import("@/components/singles/BForm/component.vue"),
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
  },
  props: { value: Boolean, data: Object },
  data() {
    return {
      isLoading: false,
      trustBrowser: this.data.twoFactorWhen !== "always",
      timerId: null,
      timeLeft: "",
      form: {
        valid: false,

        inputs: [
          {
            focus: true,
            icon: "mdi-lock",
            name: "username",
            placeholder: "Code",
            type: "number",
            validation: "numeric",
            value: "",
          },
        ],
      },
    };
  },
  computed: {},
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  async mounted() {
    if (!this.data) this.$emit("action", "signin");
    this.startCounter(60 * 5 - 1);
  },
  methods: {
    async send() {
      if (this.form.valid) {
        this.isLoading = true;

        try {
          const res = await this.$helpers.postApi(
            "2fa/verify",
            {
              fp: this.data.fingerprint,
              uid: this.data.uid,
              mail: this.data.mail,
              trustBrowser: this.trustBrowser,
              challange: this.form.inputs[0].value.trim(),
            },
            { skipDataObject: true, skipAuth: true, fullDataObject: true }
          );

          setAuth(res.data);
          await loadSettings();
          reroute();
        } catch (err) {
          const response = err.response;
          if (response && response.status === 401) {
            this.$emit("failed", this.data.mail);
            this.$emit("action", "signin");
            this.$helpers.notify("Failed", "Incorrect code.", "danger", -1);
          } else if (response && response.status === 401) {
            this.$helpers.notify("Error", "Missing parameters.", "danger");
          } else this.$helpers.notify("Error", "Unknown error.", "danger", -1);
        }

        this.isLoading = false;
        this.$helpers.clearForm(this.form);
      }
    },
    startCounter(duration) {
      let timer = duration,
        minutes,
        seconds;

      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.timeLeft = minutes + ":" + seconds;
      this.$nextTick(() => {
        this.timeLeft = minutes + ":" + seconds;
      });

      if (--timer < 0) timer = duration;

      this.timerId = setInterval(() => {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        this.$nextTick(() => {
          this.timeLeft = minutes + ":" + seconds;
        });

        if (--timer < 0) {
          this.$helpers.notify(
            "Timeout",
            "The code has expired.",
            "danger",
            -1
          );
          this.$emit("action", "signin");
          clearInterval(this.timerId);
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.card-header-title {
  display: flex;
  justify-content: space-between;
}
</style>
